// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__y2UCx","tab":"Tabs_tab__2rwDD","tabActive":"Tabs_tabActive__8vD-l"};